/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */
export function resolveComponentProps(componentProps, ownerState, slotState) {
  if (typeof componentProps === 'function') {
    return componentProps(ownerState, slotState);
  }
  return componentProps;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/utils/resolveComponentProps.js
// module id = 654
// module chunks = 0